import { useState, useEffect } from "react";
import Loader from "react-js-loader";

const Loaders = () => {
  const [loading, setLoading] = useState(true);
  const color = "white";

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (!loading) return null; 

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        left: "0px",
        width: "100%",
        top: "0px",
        position: "fixed",
        zIndex: "999999",
        backgroundColor: "rgba(0,0,0,0.8)",
      }}
    >
      <Loader type="spinner-cub" bgColor={color} size={60} />
    </div>
  );
};

export default Loaders;
